<!-- 填空题 -->
<template>
    <div class="topic_choice">
        <div class="flex topic_select mb-10">
            <!-- <div class="topic_type">填空题</div> -->
            <div class="topic_content scroll_x mar_left_10 flex-1">
                <div class="flex FlexBaseline">
                    <div>{{ subQuestionNum + 1 }}、</div>
                    <div class="topic_title" v-html="$Tools.handlerImg(topicInfo?.stem)" v-mathml></div>
                </div>
                <div v-if="!(isShowScoring || topicInfo.showAnalysis)">
                    <div class="mt-20">请将答案按顺序依次填写在下方输入框中</div>
                    <div class="answer_one mt-15" v-for="(item, index) in topicInfo?.options" :key="index">
                        <el-input v-model="item.doAnswer" :disabled="disabled" style="width: 240px"
                            :placeholder="'答案' + (index + 1)" @blur="getScore(item)" />
                    </div>
                </div>
            </div>
        </div>
        <!-- <div v-if="!testType">
            <div class="topic_answer mt-20" v-if="isShowScoring || topicInfo.showAnalysis">
                <div class="answer_top p-20">
                    <div class="flex FlexBetween">
                        <div>答题结果</div>
                        <div>总得分：{{ getTotalStudentScore(topicInfo.options) }}</div>
                    </div>
                    <div class="flex FlexBetween mt-20" style="line-height: 36px;">
                        <div>
                            <div>序号：</div>
                            <div v-for="(item, index) in topicInfo.options" :key="index">
                                <div>{{ index + 1 }}</div>
                            </div>
                        </div>
                        <div>
                            <div>参考答案：</div>
                            <div v-for="(item, index) in topicInfo.options" :key="index">
                                <div>{{ item.content }}</div>
                            </div>
                        </div>
                        <div class="mar_left_20" v-if="!hideUserAnswer">
                            <div class="user_answer">你的答案：
                                <div class="bg_line"></div>
                            </div>
                            <div v-for="(item, index) in topicInfo.options" :key="index">
                                <div>{{ item.doAnswer || "/" }}</div>
                            </div>
                        </div>
                        <div class="mar_left_20">
                            <div>得分：</div>
                            <div class="flex Flexalign" v-for="(item, index) in topicInfo.options" :key="index">
                                <el-image class="question_error_icon" :src="iconPath('question_error_icon.png')"
                                    v-if="item.isCorrect == 2"></el-image>
                                <el-image class="question_error_icon" :src="iconPath('question_correct_icon.png')"
                                    v-if="item.isCorrect == 1"></el-image>
                                <div class="get_score ml-10" v-if="!hideUserAnswer">得分：{{ item.studentScore || 0 }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <div>
            <div class="topic_answer mt-20" v-if="isShowScoring || topicInfo.showAnalysis">
                <div class="answer_top p-20" v-if="getIsShow(1) || showAnswer">
                    <div class="flex FlexBetween">
                        <div>答题结果</div>
                        <div>总得分：{{ getTotalStudentScore(topicInfo.options) }}</div>
                    </div>
                    <div class="flex FlexBetween mt-20" style="line-height: 36px;">
                        <div>
                            <div>序号：</div>
                            <div v-for="(item, index) in topicInfo.options" :key="index">
                                <div>{{ index + 1 }}</div>
                            </div>
                        </div>
                        <div>
                            <div>参考答案：</div>
                            <div v-for="(item, index) in topicInfo.options" :key="index">
                                <div>{{ item.content }}</div>
                            </div>
                        </div>
                        <div class="mar_left_20" v-if="!hideUserAnswer">
                            <div class="user_answer">你的答案：
                                <div class="bg_line"></div>
                            </div>
                            <div v-for="(item, index) in topicInfo.options" :key="index">
                                <div>{{ item.doAnswer || "/" }}</div>
                            </div>
                        </div>
                        <div class="mar_left_20">
                            <div>得分：</div>
                            <div class="flex Flexalign" v-for="(item, index) in topicInfo.options" :key="index">
                                <!-- <div class="full_score"> -->
                                <el-image class="question_error_icon" :src="iconPath('question_error_icon.png')"
                                    v-if="item.isCorrect == 2"></el-image>
                                <el-image class="question_error_icon" :src="iconPath('question_correct_icon.png')"
                                    v-if="item.isCorrect == 1"></el-image>
                                <!-- </div> -->
                                <div class="get_score ml-10" v-if="!hideUserAnswer">得分：{{ item.studentScore || 0 }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="btn_ask">提问</div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "GjkcH5Choice",
    props: {
        questionInfo: {}, disabled: {},
        subQuestionNum: {},
        isShowScoring: {
            default: false,
        },
        testType: {}, // 区分闯关，为1时是闯关,
    showAnswer:{}, // 用于测评报告弹题展示解析等
    },
    computed: {
        ...mapState({
            testExamTime: (state) => state.exam.testExamTime,
            testExamInfo: (state) => state.exam.testExamInfo,
        }),
    },

    data() {
        return {
            topicInfo: {},
        };
    },
    watch: {
        questionInfo: {
            handler(val) {
                if (val) {
                    this.topicInfo = this.questionInfo;
                    // 判断是否回答过
                    if (this.topicInfo.courseExamRecordId) {
                        // this.topicInfo.doAnswer = this.topicInfo.questionContext.doAnswer;
                    }
                }
            },
            deep: true,
            immediate: true
        },
    },

    mounted() { },

    methods: {
        getIsShow(showId) {
            let flag = false;
            if (!this.$Tools.empty(this.testExamInfo.otherRule)) {
                if (!this.$Tools.empty(this.testExamInfo.otherRule.showAnswer)) {
                    if (this.testExamInfo.otherRule.showAnswer.findIndex(item => item == showId) != -1) {
                        flag = true;
                    }
                }
            }
            return flag
        },
        getTotalStudentScore(options) {
            let total = 0;
            options.forEach(item => {
                total += Number(item.studentScore);
            })
            return total;
        },
        getScore() {
            this.topicInfo.questionScore = 0;
            this.topicInfo.doAnswer = "";
            this.topicInfo?.options.forEach(item => {
                if (item.doAnswer == item.content) {
                    this.topicInfo.questionScore += Number(item.singleScore); // 得分
                }
                this.topicInfo.doAnswer += item.doAnswer + "、"
            })
            // this.topicInfo.questionContext.isFinish = true;   // 是否已完成
            this.$emit('answerQuestion', this.topicInfo);
        },
    },
};
</script>

<style lang="scss" scoped>
.topic_select {
    .topic_type {
        // margin-top: 1rem;
        min-width: 45px;
        padding: 0 8px;
        height: 21px;
        background: rgba(0, 199, 88, 0.2);
        border-radius: 4px;
        border: 1px solid #00c758;
        line-height: 21px;
        text-align: center;
        font-size: 12px;
        color: #00c758;
    }

    .topic_content {

        // overflow-x: auto;
        .topic_title {
            font-size: 16px;
            color: #242324;
            font-weight: 600;
        }
    }
}

.bottom_box {
    position: absolute;
    left: calc(50% - 60px);
    bottom: 40px;
    text-align: center;

    .btn_view {
        width: 120px;
        height: 42px;
        background: linear-gradient(90deg, #00D5C2, #00D498);
        border-radius: 21px;
        text-align: center;
        line-height: 42px;
        color: #fff;
        font-size: 18px;
    }

    .view_analysis {
        color: #13D6AA;
    }
}

.topic_answer {
    width: 100%;
    // height: 222px;
    // background: rgba(19, 214, 170, 0.05);
    border-radius: 10px;
    // padding: 20px;
    color: #666666;
    box-sizing: border-box;

    .answer_top {
        background: #F8F9FA;
        border-radius: 8px;
        width: 100%;
        box-sizing: border-box;

        .user_answer {
            position: relative;

            .bg_line {
                width: 73px;
                height: 8px;
                background: rgba(19, 214, 170, 0.2);
                position: absolute;
                bottom: 6px;
                left: 0;
            }
        }

        .question_error_icon {
            width: 26px;
            height: 26px;
        }

        .correct_value_answer {
            color: RGBA(0, 199, 88, 1);
        }

        .error_value_answer {
            color: RGBA(255, 49, 49, 1);
        }

        .btn_ask {
            width: 64px;
            height: 28px;
            background: linear-gradient(90deg, #00d5c2, #00d498);
            border-radius: 14px;
            line-height: 28px;
            text-align: center;
            color: #fff;
        }

        .get_score {
            color: #FD673B;
        }
    }

    .question_analyze {
        color: #333333;
        font-weight: 600;
    }
}
</style>